import _typeof from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.typed.uint8-array.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import dayjs from 'dayjs';
import { decompressUint8Array } from 'utils/work/unpackResult';
import WorkTimeoutError from 'utils/errors/http/WorkTimeoutError';
import WorkResponseError from 'utils/errors/http/WorkResponseError';
import WorkerStatusCode from 'const/enums/WorkerStatusCode';
import WorkerGpuType from 'const/enums/WorkerGpuType';
var timeoutIds = {};

// While a cold worker is still provisioning we give it this long before giving up:
// the pod has to be scheduled, then download this experiment's analysis object from S3
// and load it into memory before it can answer. That whole window is mostly silent —
// the worker emits one beat when the download starts and one when the object is loaded,
// with no heartbeats in between — so the floor has to cover it without relying on beats.
var WORKER_PROVISIONING_TIMEOUT_SECONDS = 900;

// Heartbeat status codes that prove the worker already has this experiment's analysis
// object resident in memory. IDLE counts, and is in fact the strongest of them: the worker
// only polls once it has finished syncing.
var PROVISIONED_STATUS_CODES = Object.values(WorkerStatusCode).filter(function (statusCode) {
  return statusCode !== WorkerStatusCode.DOWNLOAD_EXPERIMENT;
});

// getTimeoutDate returns the date resulting of adding 'timeout' seconds to
// current time.
var getTimeoutDate = function getTimeoutDate(timeout) {
  return dayjs().add(timeout, 's').toISOString();
};
var getRemainingTimeout = function getRemainingTimeout(timeoutDate) {
  var remainingTimeout = dayjs(timeoutDate).diff(dayjs(), 's');
  return remainingTimeout;
};

// The per-task timeout the task was assigned by getTimeoutForWorkerTask (GeneExpression
// 180s, the heavy tasks 1800s, ClusterCells/Trajectory their cell-count-scaled value,
// plus any bigger-worker extra). It isn't passed in directly, but request.timeout was
// stamped as requestTime + that duration, so we recover it as the gap between them.
var getPerTaskTimeout = function getPerTaskTimeout(request) {
  return dayjs(request.timeout).diff(dayjs(request.requestTime), 's');
};

// How long we wait for the worker before giving up, computed relative to "now" so it slides
// forward each time we call it (e.g. on every heartbeat). While the worker is still
// provisioning — cold pod start + the silent S3 download/load of the analysis object — we
// hold a generous floor. Once it's loaded and actually computing we fall back to the task's
// own per-task timeout (the same value used before), so a hung/dead worker surfaces promptly
// instead of inheriting the full provisioning window. We use the per-task duration rather
// than getRemainingTimeout(request.timeout) because that deadline is anchored at dispatch and
// is already in the past once a slow cold start finishes loading.
var getWaitTimeout = function getWaitTimeout(request, workerProvisioned) {
  return workerProvisioned ? getPerTaskTimeout(request) : Math.max(getRemainingTimeout(request.timeout), WORKER_PROVISIONING_TIMEOUT_SECONDS);
};

// set a timeout and save its ID in the timeoutIds map
// if there was a timeout for the current ETag, clear it before reseting it
var setOrRefreshTimeout = function setOrRefreshTimeout(request, timeoutDuration, reject, ETag) {
  if (timeoutIds[ETag]) {
    clearTimeout(timeoutIds[ETag]);
  }

  // timeoutDate needs to be initialized outside the timeout callback
  // or it will be computed when the error is raised instead of (now)
  // when the timeout is set
  var timeoutDate = getTimeoutDate(timeoutDuration);
  timeoutIds[ETag] = setTimeout(function () {
    reject(new WorkTimeoutError(timeoutDuration, timeoutDate, request, ETag));
  }, timeoutDuration * 1000);
};
var getWorkerTimeout = function getWorkerTimeout(taskName, defaultTimeout) {
  var extraTimeoutSeconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  switch (taskName) {
    case 'GetEmbedding':
    case 'ListGenes':
    case 'MarkerHeatmap':
    case 'GetNormalizedExpression':
      {
        return dayjs().add(1800 + extraTimeoutSeconds, 's').toISOString();
      }
    default:
      {
        return dayjs().add(defaultTimeout + extraTimeoutSeconds, 's').toISOString();
      }
  }
};
var waitForWorkRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ETag, experimentId, request, dispatch, parser) {
    var _request$workerGpuTyp;
    var _yield$import, connectionPromise, io, requestedWorkerGpuType, heartbeatEvent, responseEvent, onHeartbeat, onWorkResponse, workerProvisioned, cleanup, timeoutPromise, responsePromise;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return import('utils/socketConnection');
        case 2:
          _yield$import = _context2.sent;
          connectionPromise = _yield$import.default;
          _context2.next = 6;
          return connectionPromise();
        case 6:
          io = _context2.sent;
          // request.timeout is the deadline we sent the worker (it skips the request once
          // it passes, but it adds its own cold-start buffer first). In the UI we wait for
          // the larger of that remaining time and a floor, sliding the deadline forward on every
          // heartbeat — as long as we keep hearing from the worker we know it's alive and
          // progressing, so we keep waiting. The floor starts at the generous provisioning window
          // and shrinks to the per-task compute budget once the worker reports the object loaded.
          // this should be removed if we make each request run in a different worker
          // Which worker took this request, stamped on the request by dispatchWorkRequest from the
          // API's response. null when the API didn't say (an older API, or running locally).
          requestedWorkerGpuType = (_request$workerGpuTyp = request === null || request === void 0 ? void 0 : request.workerGpuType) !== null && _request$workerGpuTyp !== void 0 ? _request$workerGpuTyp : null;
          heartbeatEvent = "Heartbeat-".concat(experimentId);
          responseEvent = "WorkResponse-".concat(ETag);
          // Flips true once a heartbeat proves the analysis object is loaded, which ends the
          // cold-start provisioning window and drops the give-up floor to the compute budget.
          workerProvisioned = false; // Once this request settles (responded / errored / timed out) we drop the pending
          // timeout and stop listening. Heartbeats are emitted per-experiment, not per-ETag,
          // so without removing the listener a finished request keeps reacting to every later
          // request on the same experiment: it re-arms a stale timeout for this ETag (undoing
          // the clear below) and fires redundant status dispatches. Leaving listeners also
          // leaks one per request and makes timeouts non-deterministic when an ETag is reused.
          cleanup = function cleanup() {
            if (timeoutIds[ETag]) {
              clearTimeout(timeoutIds[ETag]);
              delete timeoutIds[ETag];
            }
            if (onHeartbeat) io.off(heartbeatEvent, onHeartbeat);
            if (onWorkResponse) io.off(responseEvent, onWorkResponse);
          };
          timeoutPromise = new Promise(function (resolve, reject) {
            setOrRefreshTimeout(request, getWaitTimeout(request, workerProvisioned), reject, ETag);

            // Heartbeats are only watched here to decide how long to keep waiting. Turning them
            // into status messages is workerHeartbeatHandler's job, on one subscription for the
            // whole experiment, so a worker's status is visible to every task queued on it.
            onHeartbeat = function onHeartbeat(_ref2) {
              var statusCode = _ref2.statusCode,
                gpu = _ref2.gpu;
              var beatWorkerGpuType = typeof gpu === 'boolean' ? gpu ? WorkerGpuType.GPU : WorkerGpuType.NON_GPU : null;

              // Only our own worker reporting the object loaded ends the cold-start window: from
              // here on use the shorter compute floor so a hung worker surfaces promptly instead
              // of after the full provisioning window. A beat we can't place leaves the generous
              // floor in place, which only ever errs towards waiting longer.
              var isOurWorker = beatWorkerGpuType !== null && beatWorkerGpuType === requestedWorkerGpuType;
              if (isOurWorker && PROVISIONED_STATUS_CODES.includes(statusCode)) {
                workerProvisioned = true;
              }

              // Any heartbeat means a worker is alive and progressing, including one for another
              // task: ours may simply be queued behind it. Slide the deadline forward.
              setOrRefreshTimeout(request, getWaitTimeout(request, workerProvisioned), reject, ETag);
            };
            io.on(heartbeatEvent, onHeartbeat);
          });
          responsePromise = new Promise(function (resolve, reject) {
            onWorkResponse = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                var response, userMessage, decompressedData;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(_typeof(res) === 'object')) {
                        _context.next = 6;
                        break;
                      }
                      response = res.response;
                      if (!response.error) {
                        _context.next = 5;
                        break;
                      }
                      userMessage = response.userMessage;
                      return _context.abrupt("return", reject(new WorkResponseError(userMessage, request)));
                    case 5:
                      return _context.abrupt("return", resolve({
                        signedUrl: response.signedUrl
                      }));
                    case 6:
                      _context.prev = 6;
                      _context.next = 9;
                      return decompressUint8Array(Uint8Array.from(Buffer.from(res, 'base64')));
                    case 9:
                      decompressedData = _context.sent;
                      return _context.abrupt("return", resolve({
                        data: parser(decompressedData)
                      }));
                    case 13:
                      _context.prev = 13;
                      _context.t0 = _context["catch"](6);
                      return _context.abrupt("return", reject(_context.t0));
                    case 16:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[6, 13]]);
              }));
              return function onWorkResponse(_x6) {
                return _ref3.apply(this, arguments);
              };
            }();
            io.on(responseEvent, onWorkResponse);
          }); // TODO switch to using normal WorkRequest for v2 requests
          _context2.prev = 14;
          _context2.next = 17;
          return Promise.race([timeoutPromise, responsePromise]);
        case 17:
          return _context2.abrupt("return", _context2.sent);
        case 18:
          _context2.prev = 18;
          // Whatever the outcome, cancel the pending timeout (up to 15 min) so it can't
          // fire after we've settled, and detach the socket listeners.
          cleanup();
          return _context2.finish(18);
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[14,, 18, 21]]);
  }));
  return function waitForWorkRequest(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
export { getWorkerTimeout, WORKER_PROVISIONING_TIMEOUT_SECONDS };
export default waitForWorkRequest;